import { render } from "./ApplicationStep3.vue?vue&type=template&id=15dc98f2"
import script from "./ApplicationStep3.vue?vue&type=script&lang=js"
export * from "./ApplicationStep3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__